/**
 * @generated SignedSource<<70be00dd15a842e2170bb44f887bd040>>
 * @relayHash 7ed1e317e90fc777adf227a379521cab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID manual

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ConfluenceUpdateSmartSpaceOverviewInput = {
  spaceKey: string;
  summary?: ConfluenceUpdateSmartSpaceOverviewSummaryInput | null | undefined;
  topLinks?: ConfluenceUpdateSmartSpaceOverviewTopLinksInput | null | undefined;
};
export type ConfluenceUpdateSmartSpaceOverviewSummaryInput = {
  body?: string | null | undefined;
};
export type ConfluenceUpdateSmartSpaceOverviewTopLinksInput = {
  add?: ConfluenceAddTopLinkInput | null | undefined;
  edit?: ConfluenceEditTopLinkInput | null | undefined;
  remove?: ConfluenceRemoveTopLinkInput | null | undefined;
};
export type ConfluenceAddTopLinkInput = {
  isPinned?: boolean | null | undefined;
  title?: string | null | undefined;
  url: string;
};
export type ConfluenceEditTopLinkInput = {
  isPinned?: boolean | null | undefined;
  url: string;
};
export type ConfluenceRemoveTopLinkInput = {
  url: string;
};
export type SmartSpaceOverviewSummaryUpdateMutation$variables = {
  cloudId: string;
  input: ConfluenceUpdateSmartSpaceOverviewInput;
};
export type SmartSpaceOverviewSummaryUpdateMutation$data = {
  readonly confluence_updateSmartSpaceOverview: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly overview: {
      readonly summary: {
        readonly body: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type SmartSpaceOverviewSummaryUpdateMutation = {
  response: SmartSpaceOverviewSummaryUpdateMutation$data;
  variables: SmartSpaceOverviewSummaryUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceUpdateSmartSpaceOverviewPayload",
    "kind": "LinkedField",
    "name": "confluence_updateSmartSpaceOverview",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceSmartSpaceOverview",
        "kind": "LinkedField",
        "name": "overview",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSmartSpaceOverviewSummary",
            "kind": "LinkedField",
            "name": "summary",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "body"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SmartSpaceOverviewSummaryUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SmartSpaceOverviewSummaryUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7ed1e317e90fc777adf227a379521cab",
    "id": "manual",
    "metadata": {},
    "name": "SmartSpaceOverviewSummaryUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation SmartSpaceOverviewSummaryUpdateMutation($cloudId:ID!,$input:ConfluenceUpdateSmartSpaceOverviewInput!){confluence_updateSmartSpaceOverview(cloudId:$cloudId,input:$input){success,errors{message},overview{summary{body}}}}"
  }
};
})();

(node as any).hash = "c07da228d9ec183b11eb802e583c9e4e";

export default node;
